export function packageParts(config, choice) {
  if (!['rail', 'lp9', 'lp6'].includes(choice)) throw new Error('Invalid package');
  const parts = [{ ...config.rail, quantity: 1, name: config.strings.rail_name }];
  if (choice !== 'rail') parts.push({ ...config[choice], quantity: 2, name: config.strings[choice + '_name'] }, { ...config.harness, quantity: 1, name: config.strings.harness_name });
  return parts;
}

export function packageItems(config, choice, quantity) {
  if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) throw new Error('Invalid quantity');
  return packageParts(config, choice).map(part => {
    if (!part.id || !part.available || !Number.isInteger(part.price)) throw new Error('Unavailable component');
    return { id: part.id, quantity: part.quantity * quantity, properties: choice === 'rail' ? {} : { Package: config.strings[choice + '_option'] } };
  });
}

function initialize(root) {
  if (root.dataset.initialized) return;
  const config = JSON.parse(root.querySelector('[data-rail-config]').textContent);
  const form = root.querySelector('form');
  const select = root.querySelector('[data-rail-package]');
  const quantity = form.querySelector('[name="quantity"]');
  const button = root.querySelector('[data-rail-add]');
  const error = root.querySelector('[data-rail-error]');
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: config.currency }).format(value / 100);
  let busy = false;
  const available = choice => packageParts(config, choice).every(part => part.id && part.available && Number.isInteger(part.price));
  for (const option of select.options) {
    option.disabled = !available(option.value);
    if (option.disabled) option.textContent += ' — ' + config.strings.sold_out;
  }
  function render() {
    const choice = select.value;
    const parts = packageParts(config, choice);
    const count = Number(quantity.value);
    const validQuantity = Number.isInteger(count) && count >= 1 && count <= 99;
    root.querySelector('[data-rail-description]').textContent = config.strings[choice + '_description'];
    const breakdown = root.querySelector('[data-rail-breakdown]');
    breakdown.replaceChildren();
    for (const part of parts) {
      const row = document.createElement('div');
      const name = document.createElement('dt');
      const amount = document.createElement('dd');
      name.textContent = part.quantity + ' × ' + part.name + ' · ' + config.strings.sku + ' ' + (part.sku || '');
      amount.textContent = Number.isInteger(part.price) ? money(part.price * part.quantity * (validQuantity ? count : 1)) : config.strings.unavailable;
      row.append(name, amount);
      breakdown.append(row);
    }
    root.querySelector('[data-rail-total]').textContent = parts.every(part => Number.isInteger(part.price)) ? money(parts.reduce((sum, part) => sum + part.price * part.quantity, 0) * (validQuantity ? count : 1)) : config.strings.unavailable;
    button.disabled = busy || !validQuantity || !available(choice);
    button.textContent = busy ? config.strings.adding : available(choice) ? (choice === 'rail' ? config.strings.add : config.strings.add_package) : config.strings.sold_out;
  }
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    let items;
    try { items = packageItems(config, select.value, Number(quantity.value)); }
    catch { error.textContent = config.strings.unavailable; error.hidden = false; return; }
    busy = true;
    error.hidden = true;
    render();
    try {
      const response = await fetch(config.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.strings.add_error);
      window.location.assign(config.cartUrl);
    } catch (reason) {
      error.textContent = reason.message === 'Failed to fetch' ? config.strings.network_error : reason.message || config.strings.add_error;
      error.hidden = false;
      busy = false;
      render();
    }
  });
  select.addEventListener('change', render);
  quantity.addEventListener('input', render);
  select.disabled = false;
  root.dataset.initialized = 'true';
  render();
}

if (typeof document !== 'undefined') {
  const start = () => document.querySelectorAll('[data-eev-rail-product]').forEach(initialize);
  start();
  document.addEventListener('shopify:section:load', start);
}
